const images = [
  "sorafes-cloud.jpg",
  "sorafes-cloud.jpg",
  "sorafes-cloud.jpg",
  "sorafes-cloud.jpg",
  "sorafes-cloud.jpg",
  "sorafes-cloud.jpg",
];

export default images;
